<template>
  <div class="form-group">
    <div class="form-group__radio-legend">{{ legend }}</div>
    <div class="custom-control custom-radio" v-for="(option, index) in options" :key="index" v-bind:class="{'is-invalid': baseInput.showErrors()}">
      <input type="radio" :name="radioGroupName" :value="option[valueField]" :id="`${ radioGroupName}-${ option[valueField] }`" class="custom-control-input"
        v-on:change="setValue($event, radioGroupName)" :checked="value === option[valueField]">
      <label class="custom-control-label" :for="`${ radioGroupName}-${ option[valueField] }`">
        {{ option[labelField] }}
      </label>
    </div>
    <div class="invalid-feedback" v-if="baseInput.showErrors()">
      <span v-for="(error, index) in baseInput.errors()" v-bind:key="index">
        {{error}}
      </span>
    </div>
  </div>
</template>

<script>
import useBaseInput from 'client/js/composition/base-input'

export default {
  props: {
    legend: { type: String },
    value: { type: String },
    radioGroupName: { type: String },
    label: { type: String },
    id: { type: String },
    invalidText: { type: String },
    helpText: { type: String, default: null },
    ariaLabelText: { type: String, default: null },
    options: {
      type: Array,
      required: false
    },
    defaultText: {
      type: String,
      required: false,
      default: null
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    valueField: {
      type: String,
      required: false,
      default: 'value'
    },
    labelField: {
      type: String,
      required: false,
      default: 'label'
    },
    errors: {
      type: Array,
      required: false,
      default: []
    }
  },
  setup(props, context) {
    return {
      baseInput: useBaseInput(props, context)
    }
  },
  data() {
    return {
      checked: null
    }
  },
  computed: {},
  methods: {
    setValue(event, radioGroupName) {
      if (event.target.value) {
        this.checked = event.target.value
        this.$emit('input', radioGroupName, this.checked)
      }
    },
    clearValue() {
      this.$emit('input', this.radioGroupName, null)
    }
  },

  mounted() {},
}
</script>
